/**
 * Zeitleiste der Version 5 „Kombi“. Die Bögen kommen aus Version 4
 * (Rückblende, Zurückspulen, Menschen statt Lebensläufe), die Stationen im
 * Prozess aus Version 3. Die ids der Prozess-Stationen sind dieselben wie in
 * v3/beats.js, so laufen die Panels aus v3 über `BeatsProvider` mit.
 *
 * `len` ist die Länge in vh, daraus ergeben sich die Bereiche auf --l.
 */

const RAW = [
  { id: 'intro', label: 'Start', len: 100 },
  {
    id: 'ohne',
    label: 'Ohne Aivy',
    len: 480,
    text: 'Customer Success sucht Verstärkung. Mara aus dem HR prüft jede Bewerbung gründlich, doch Lebensläufe zeigen Stationen, keine Stärken. Der Neue überzeugt auf dem Papier, passt aber nicht ins Team, und kurz darauf ist der Platz wieder frei.'
  },
  {
    id: 'rewind',
    label: 'Zurückspulen',
    len: 130,
    text: 'Eine Fehlbesetzung kostet Zeit, Geld und Nerven. Also spulen wir zurück.'
  },
  {
    id: 'hr',
    label: 'HR startet mit Aivy',
    len: 180,
    text: 'Diesmal holt sich Mara Aivy für die Vorauswahl dazu. Sie startet mit einer Aivy-Vorlage für die Stelle, bindet die Fachbereiche ein oder kombiniert beides.'
  },
  {
    id: 'analyse',
    label: 'Die Anforderungsanalyse',
    len: 230,
    text: 'Die Fachbereiche definieren die Anforderungen selbst, jede Person für sich in der Aivy Anforderungsanalyse. HR hat keinen Aufwand, und am Ende sprechen alle dieselbe Sprache.'
  },
  {
    id: 'profil',
    label: 'Das Anforderungsprofil',
    len: 170,
    text: 'Aivy berechnet daraus das Anforderungsprofil, mit Ideal- und Übergangsbereich für jede Anforderung. Das ist die Grundlage fürs Matching.'
  },
  {
    id: 'bewerbungen',
    label: 'Aus Lebensläufen werden Menschen',
    len: 230,
    text: 'Dann kommen die Bewerbungen, sehr viele davon. Doch hinter jedem Lebenslauf steckt ein Mensch, mit Stärken, die auf keinem Papier stehen.'
  },
  {
    id: 'games',
    label: 'Game-based Assessment',
    len: 230,
    text: 'Aivy schickt allen das Game-based Assessment. Kurze Spiele am Smartphone oder im Web, und jede Person zeigt, was in ihr steckt.'
  },
  {
    id: 'magic',
    label: 'Ein Blick in Aivy',
    len: 190,
    text: 'Was passiert in Aivy? Aus dem Spielverhalten werden validierte Dimensionen. Die gleicht Aivy mit dem Anforderungsprofil ab und berechnet daraus die Passung.'
  },
  {
    id: 'regeln',
    label: 'Gleiche Regeln für alle',
    len: 170,
    text: 'Die Passung ist regelbasiert. Aivy gleicht alle nach denselben festen Regeln ab, keine Blackbox, jede Passung bleibt nachvollziehbar.'
  },
  {
    id: 'talente',
    label: 'Bewerbende lieben es',
    len: 150,
    text: 'Und die Bewerbenden? Bekommen ihr persönliches Stärkenprofil, komplett kostenlos. Das schafft Akzeptanz, denn spielen macht mehr Spaß als jeder Fragebogen.'
  },
  {
    id: 'report',
    label: 'Shortlist und Passungsprofil',
    len: 230,
    text: 'Die drei passendsten Personen treten vor. Das Kernstück für Mara ist das ausführliche Passungsprofil als PDF, der Aivy Assistent hilft zusätzlich beim schnellen Nachfragen.'
  },
  {
    id: 'kreuz',
    label: 'Kreuzmatching',
    len: 150,
    text: 'Jonas passt nicht ins Customer Success, aber perfekt in den Vertrieb. Dank Kreuzmatching geht dieses Talent nicht verloren.'
  },
  {
    id: 'gespraech',
    label: 'Das Gespräch',
    len: 190,
    text: 'Lena kommt ins Gespräch. Die Interviewfragen schlägt Aivy auf Basis ihres Passungsprofils vor, genau zu den Punkten, die sich zu vertiefen lohnen.'
  },
  {
    id: 'team',
    label: 'Das neue Team',
    len: 150,
    text: 'Lena setzt sich zu ihrem neuen Team. Sie passt zur Aufgabe und zur Kultur, und diesmal bleibt der Platz besetzt.'
  },
  {
    id: 'absagen',
    label: 'Faire Absagen',
    len: 170,
    text: 'Und alle anderen? Gehen mit ihrem Stärkenprofil. Bewertet nach denselben Kriterien, datenbasiert und fair. Das gibt HR Sicherheit, auch rechtlich.'
  },
  {
    id: 'ats',
    label: 'Im eigenen ATS',
    len: 110,
    text: 'Aivy läuft auch in deinem ATS. Mit dem Sidebar-Plugin hast du den Assistenten und die volle Auswertung direkt im System, in dem du ohnehin arbeitest.'
  },
  {
    id: 'support',
    label: 'Support',
    len: 90,
    text: 'Und wenn mal eine Frage offen ist? Unser Support hilft dir gern, schnell und persönlich.'
  },
  { id: 'finale', label: 'Der Vergleich', len: 150 }
]

export const TOTAL_VH = RAW.reduce((sum, b) => sum + b.len, 0)

export const BEATS = RAW.reduce((list, b) => {
  const start = list.length ? list[list.length - 1].at[1] : 0
  list.push({ ...b, at: [start, start + b.len / TOTAL_VH] })
  return list
}, [])

const B = Object.fromEntries(BEATS.map((b) => [b.id, b.at]))

export const inB = (beat, a, b) => {
  const [s, e] = B[beat]
  const len = e - s
  return [s + a * len, s + b * len]
}

export const atB = (beat, a) => inB(beat, a, a)[0]
